import {
  ModalCloseButton,
  View,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CheckoutSummaryRootParamList } from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ParamListBase } from "@react-navigation/native";
import { CheckoutEmailReceiptScreen } from "../CheckoutEmailReceiptScreen";
import { CheckoutReviewScreen } from "../CheckoutReviewScreen";
import { CustomerRootScreen } from "../CustomerRootScreen";
import { CheckoutSummaryMoreActionsRootScreen } from "../CheckoutSummaryMoreActionsRootScreen";

export type EditProductRootScreenProps = StackScreenProps<
  ParamListBase,
  "EditProductRootScreen"
>;

export const CheckoutSummaryRootScreen = () => {
  const Stack = createStackHeaderNavigator<CheckoutSummaryRootParamList>();

  return (
    <Stack.Navigator
      screenOptions={{
        animationEnabled: true,
        gestureEnabled: false,
      }}
    >
      <Stack.Group
        screenOptions={{
          headerLeft: () => <ModalCloseButton />,
        }}
      >
        <Stack.Screen
          name="CheckoutReviewScreen"
          component={CheckoutReviewScreen}
          options={{
            headerShown: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <View />,
          }}
        />
      </Stack.Group>
      <Stack.Group
        screenOptions={{
          presentation: "modal",
          headerLeft: () => <ModalCloseButton />,
          headerShown: true,
          headerStyle: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Stack.Screen
          name="CheckoutEmailReceiptScreen"
          component={CheckoutEmailReceiptScreen}
          options={{
            headerTitle: "Email Receipt",
          }}
        />
        <Stack.Screen
          name="CustomerRootScreen"
          component={CustomerRootScreen}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="CheckoutSummaryMoreActionsRootScreen"
          component={CheckoutSummaryMoreActionsRootScreen}
          options={{
            headerShown: false,
          }}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
};
